import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-task-agreement-dialog',
  templateUrl: './task-agreement-dialog.component.html',
  styleUrls: ['./task-agreement-dialog.component.scss']
})
export class TaskAgreementDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<TaskAgreementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onAgreeClick() {
    this.dialogRef.close('agree');
  }

  onNoClick() {
    this.dialogRef.close('no');
  }

}
